/**
 * client/src/lib/return-to.ts
 *
 * Same-origin, no-scheme, length-bounded validation for ?returnTo= query
 * params. Used by /auth route guard (App.tsx) and AuthEntry post-success
 * navigation. See spec AC-8.
 *
 * Mitigates OWASP A01:2021 (open redirect via post-auth navigation). The
 * `:` rejection plus the same-origin `/` prefix together close off
 * `javascript:`, `data:`, `vbscript:`, protocol-relative `//evil.com`,
 * and absolute cross-origin URLs.
 */

export function validateReturnTo(raw: string | null): string | null {
  if (!raw) return null;
  if (!raw.startsWith("/")) return null;
  if (raw.startsWith("//")) return null;        // protocol-relative
  if (raw.includes(":")) return null;            // javascript: / data: / etc.
  if (raw.length > 512) return null;             // bound input
  return raw;
}
